import 'antd/dist/reset.css' // antd core styles
import './global.scss' // app & third-party component styles
import './dayjs.config' // register dayjs plugins/locale for antd pickers

import React from 'react'
import { createRoot } from 'react-dom/client'
import { createHashHistory } from 'history'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'

import reducers from './redux/reducers'
import sagas from './redux/sagas'
import Localization from './localization'
import Router from './router'
import * as serviceWorker from './serviceWorker'

// Login codes arrive as ?code=... on the root URL, the same shape the student
// app uses, optionally with ?redirect= naming the in-app page to land on
// after signing in. Move both into the hash before the history is created, so
// the router starts on the route that redeems the code and the code stops
// being part of a URL that would be sent to the server again on a reload.
const handoffParams = new URLSearchParams(window.location.search)
const handoffCode = handoffParams.get('code')
if (handoffCode) {
  const handoffRedirect = handoffParams.get('redirect')
  handoffParams.delete('code')
  handoffParams.delete('redirect')
  const remaining = handoffParams.toString()
  const hashParams = new URLSearchParams({ code: handoffCode })
  if (handoffRedirect) {
    hashParams.set('redirect', handoffRedirect)
  }
  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}${
      remaining ? `?${remaining}` : ''
    }#/auth/handoff?${hashParams.toString()}`,
  )
}

// middlewared
const history = createHashHistory()
const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware]
const store = createStore(reducers(history), compose(applyMiddleware(...middlewares)))
sagaMiddleware.run(sagas)

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <Localization>
      <>
        <Router history={history} />
      </>
    </Localization>
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history }
